import { ReplyRecommendationCitationsList } from './ReplyRecommendationCitationsList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PopoverBody, PopoverHeader } from 'foundations-components/transitional/components/Popover';
import { H4 } from 'foundations-components/transitional/components/H4';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReplyRecommendationCitationPopoverContent = ({
  citationsList
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PopoverHeader, {
      children: /*#__PURE__*/_jsx(H4, {
        typography: "heading-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.reply-recommendations.citations.popoverHeader"
        })
      })
    }), /*#__PURE__*/_jsx(PopoverBody, {
      paddingBlockEnd: "500",
      children: /*#__PURE__*/_jsx(ReplyRecommendationCitationsList, {
        citationsList: citationsList
      })
    })]
  });
};
ReplyRecommendationCitationPopoverContent.displayName = 'ReplyRecommendationCitationPopoverContent';